import {appendPaginationQueryParamsToUrl, get} from '../utils'
import {getActiveChannel, getActiveClient} from "../authentication/utils";

export default host => (entity, type, tags=[], not_tags=[], options) =>
  get(appendPaginationQueryParamsToUrl(`${host}/clients/${getActiveClient()}/${getActiveChannel() ? `channels/${getActiveChannel()}/` : ``}countries/${entity}?${type ? `&type=${type}` : ''}${tags.length !==0 ? `&tags_ids=${tags.join(',')}` : ''}${not_tags.length !==0 ? `&not_tags_ids=${not_tags.join(',')}` : ''}`, {...options, alreadyHasQueryParams: true}))
    .then(response => response.json())
    .then(json => json.meta ? json : json.data)


